
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SocialProofSection from './components/SocialProofSection';
import CaseStudyPreviewSection from './components/CaseStudyPreviewSection';
import AboutSection from './components/AboutSection';
import FinalCTASection from './components/FinalCTASection';

export default function HomePage() {
  useEffect(() => {
    document.title = 'SparkBoost Labs | AI Revenue Systems | Predictable Growth for Service Companies';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI revenue systems experts helping service companies build predictable growth. Eliminate feast-or-famine cycles with proven automation and sales optimization.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <SocialProofSection />
        <CaseStudyPreviewSection />
        <AboutSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
